import { AssociationRequestV2, userAssociateV2 } from "../hooks/be";

export const CreateAssociationV2 = async () => {
  const userData: AssociationRequestV2 = {
    userId: localStorage.getItem("userId") || "",
    providerId: localStorage.getItem("providerId") || ""
  };

  const { associate } = userAssociateV2();
  return await associate(userData);
};
